import { Fragment } from 'react'
import { brand } from '../brand'
import {
    CopyrightBar,
    FooterBrandContent,
    FooterCities,
    FooterLogoCell,
    FooterLogos,
    FooterMain,
    FooterRoot,
    FooterEnrollLink,
} from './styles/Footer.styled'

const assetBase = `/brands/${brand.id}`

const companyLogos = [
    {
        src: `${assetBase}/logo-footer-em.webp`,
        alt: 'TEG Energy Management',
    },
    {
        src: `${assetBase}/logo-footer-pip.webp`,
        alt: 'Power Infrastructure Partners',
    },
    {
        src: `${assetBase}/logo-footer-digital.png`,
        alt: 'TEG Digital',
    },
]

const cities = ['Dallas', 'Midland', 'Austin']

const Footer = () => {
    return (
        <FooterRoot role="contentinfo">
            <FooterMain>
                <FooterLogos>
                    <FooterLogoCell className="brand-cell">
                        <FooterBrandContent>
                            <img
                                className="brand-logo"
                                src={brand.logos.footer.src}
                                alt={brand.logos.footer.alt}
                                width={brand.logos.footer.width}
                                height={brand.logos.footer.height}
                            />
                            <FooterEnrollLink href="/">Enroll Now</FooterEnrollLink>
                        </FooterBrandContent>
                    </FooterLogoCell>
                    {companyLogos.map((logo) => (
                        <FooterLogoCell key={logo.alt}>
                            <img src={logo.src} alt={logo.alt} />
                        </FooterLogoCell>
                    ))}
                </FooterLogos>

                <FooterCities>
                    {cities.map((city, index) => (
                        <Fragment key={city}>
                            <span className="city">{city}</span>
                            {index < cities.length - 1 && (
                                <span className="separator" aria-hidden="true">·</span>
                            )}
                        </Fragment>
                    ))}
                </FooterCities>
            </FooterMain>

            <CopyrightBar>
                <div className="inner">
                    <p>
                        &copy; {new Date().getFullYear()} {brand.nameUpper}.
                    </p>
                </div>
            </CopyrightBar>
        </FooterRoot>
    )
}

export default Footer
